import script from "./BlogHeaderComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogHeaderComponent.vue?vue&type=script&setup=true&lang=js"

import "./BlogHeaderComponent.vue?vue&type=style&index=0&id=c5bb64b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5bb64b0"]])

export default __exports__